// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  box-sizing: border-box;
  text-align: center;
  margin: 0px;
  padding: 0px;
  height: 100vh;
  background-color: #eff2f6;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

:root {
  margin: 0px;
  padding: 0px;
  background-color: #eff2f6;
  --primary-color: #54a38e; /* Define un color primario */
  --primary-color-seleccionado: #e6f4f1; /* Define un color primario */
  --primary-color-hover: #458a78; /* Define un color primario */
  --secondary-color: #459680; /* Define un color secundario */
  --accent-color: #357262; /* Define un color de acento */
  --text-color: #333; /* Define un color de texto común */
  --text-color-claro: #5d5c5c; /* Define un color de texto común */
  --text-color-claro-2: #808080; /* Define un color de texto común */
  --background-color: #ff;
  --gris-claro: #e3e5e8;
  --gris-fondo: #eef2f6;
  --gris-separador: #7d8796;
  --amarillo-ayuda: #fff5be;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.App-fondo {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 600px) {
  :root {
    background-color: #ffffff; /* Cambia el color de fondo para dispositivos móviles */
  }
  .App-fondo {
    margin-top: 0;
    margin-bottom: 0;
    background-color: #ffffff; /* Cambia el color de fondo para dispositivos móviles */
  }
}

.Card {
  background-color: #ffffff;

  padding-left: 30px;
  padding-right: 30px;
  padding-top: 20px;
  /* margin-top: 50px; */
}

.tituloVerde {
  color: var(--primary-color);
  font-size: 1.6rem;
}

.tituloNegro {
  color: black;
  font-size: 1.6rem;
}

.subtituloNegro {
  color: black;
  font-size: 1.2rem;
  font-weight: bold;
  width: auto;
}

.subtituloNegro2 {
  color: black;
  font-size: 1rem;
  width: auto;
  align-items: center;
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,wBAAwB,EAAE,6BAA6B;EACvD,qCAAqC,EAAE,6BAA6B;EACpE,8BAA8B,EAAE,6BAA6B;EAC7D,0BAA0B,EAAE,+BAA+B;EAC3D,uBAAuB,EAAE,8BAA8B;EACvD,kBAAkB,EAAE,mCAAmC;EACvD,2BAA2B,EAAE,mCAAmC;EAChE,6BAA6B,EAAE,mCAAmC;EAClE,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,yBAAyB,EAAE,uDAAuD;EACpF;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,yBAAyB,EAAE,uDAAuD;EACpF;AACF;;AAEA;EACE,yBAAyB;;EAEzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".App {\n  box-sizing: border-box;\n  text-align: center;\n  margin: 0px;\n  padding: 0px;\n  height: 100vh;\n  background-color: #eff2f6;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n:root {\n  margin: 0px;\n  padding: 0px;\n  background-color: #eff2f6;\n  --primary-color: #54a38e; /* Define un color primario */\n  --primary-color-seleccionado: #e6f4f1; /* Define un color primario */\n  --primary-color-hover: #458a78; /* Define un color primario */\n  --secondary-color: #459680; /* Define un color secundario */\n  --accent-color: #357262; /* Define un color de acento */\n  --text-color: #333; /* Define un color de texto común */\n  --text-color-claro: #5d5c5c; /* Define un color de texto común */\n  --text-color-claro-2: #808080; /* Define un color de texto común */\n  --background-color: #ff;\n  --gris-claro: #e3e5e8;\n  --gris-fondo: #eef2f6;\n  --gris-separador: #7d8796;\n  --amarillo-ayuda: #fff5be;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.App-fondo {\n  width: 100%;\n  height: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n@media (max-width: 600px) {\n  :root {\n    background-color: #ffffff; /* Cambia el color de fondo para dispositivos móviles */\n  }\n  .App-fondo {\n    margin-top: 0;\n    margin-bottom: 0;\n    background-color: #ffffff; /* Cambia el color de fondo para dispositivos móviles */\n  }\n}\n\n.Card {\n  background-color: #ffffff;\n\n  padding-left: 30px;\n  padding-right: 30px;\n  padding-top: 20px;\n  /* margin-top: 50px; */\n}\n\n.tituloVerde {\n  color: var(--primary-color);\n  font-size: 1.6rem;\n}\n\n.tituloNegro {\n  color: black;\n  font-size: 1.6rem;\n}\n\n.subtituloNegro {\n  color: black;\n  font-size: 1.2rem;\n  font-weight: bold;\n  width: auto;\n}\n\n.subtituloNegro2 {\n  color: black;\n  font-size: 1rem;\n  width: auto;\n  align-items: center;\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
